import React from 'react'
import {Layout} from 'components'
import Microinsurance from 'images/icons/microinsurance.png'
import DigipayLogo from 'images/icons/digipay-logo-white.png'
import MicroEnsure from 'images/icons/microensure.png'
import Axa from 'images/icons/axa.png'
import ManWoman from 'images/icons/manwoman.svg'
import HeartIcon from 'images/icons/benefits.svg'
import Waiting from 'images/icons/waiting.svg'
import Grace from 'images/icons/grace.svg'
import Checkbox from 'images/icons/checkbox.svg'
import Injection from 'images/icons/injection.svg'
import Buildings from 'images/building-footer.png'
import Facebook from 'images/icons/fb.png'
import Instagram from 'images/icons/ig.png'
import LinkedIn from 'images/icons/linkedin.png'
import 'styles/app.scss'

const FOOTER_BG = {
  backgroundImage: `url(${Buildings})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat'
}

function IndexPage() {
  return (
    <Layout>
      <section className="bg-red-3 pd-x-8 md-pd-x-10 pd-y-3">
        <div className="Row justify-center align-center mg-bt-3">
          <img src={Microinsurance} alt="Microinsurance Icon" />
          <h1 className="text-light-0 text-center fs-8 md-fs-12 md-ls-wide text-3d">
            HealthGuard
          </h1>
        </div>

        <p className="lg-width-half mg-y-auto mg-x-6 text-light-0 text-center fs-4">
          An affordable and accessible health insurance solution brought to you by{' '}
          Digipay, AXA, and MicroEnsure
        </p>

        <div className="Row justify-center">
          <div className="Column size-12 md-size-3 mg-x-4 mg-y-3">
            <div className="Row justify-center lg-justify-end align-center height-full">
              <img src={DigipayLogo} alt="Digipay Logo"/>
            </div>
          </div>

          <div className="Column size-12 md-size-3 lg-size-2 xl-size-1 mg-x-4 mg-y-3">
            <div className="Row justify-center">
              <img src={Axa} alt="AXA Logo"/>
            </div>
          </div>

          <div className="Column size-12 md-size-3 mg-x-4 mg-y-3">
            <div className="Row justify-center">
              <img
                src={MicroEnsure}
                alt="MicroEnsure Logo"
                className="bg-light-0 pd-2"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="pd-y-3 lg-pd-y-5 mg-x-6 lg-mg-tp-10">
        <div className="Row">
          <div className="Column size-12 lg-size-6">
            <div className="Row md-align-center lg-align-start">
              <div
                className={
                  'Column size-12 md-size-6 pd-3 text-light-0 ' +
                  'text-center bg-red-4 fs-5 lg-fs-5 xl-fs-7 ' +
                  'rounded-3 mg-bt-3'
                }
              >
                <h1>ELIGIBILITY</h1>
                <h1>18 - 64</h1>
                <h1>years old</h1>
              </div>

              <div className="Column size-12 md-size-6 text-center mg-bt-3">
                <img
                  src={ManWoman}
                  alt="Man & Woman"
                  width="256px"
                  height="256px"
                />
              </div>
            </div>
          </div>

          <div className="Column size-12 lg-size-6 pd-lt-4">
            <div className="Row align-center fs-7 mg-bt-3">
              <img
                src={HeartIcon}
                alt="Abstract Heart Icon"
                width="48px"
                height="48px"
                className="mg-rt-3"
              />
              <h1 className="fs-7">
                BENEFITS
              </h1>
            </div>

            <ul className="mg-lt-5 lg-mg-lt-9 fs-3 lg-fs-5 lh-quarter">
              <li className="mg-bt-2">
                Daily Hospital Income (Minimum of 3 consecutive days of confinement)
              </li>
              <li>Accidental Death</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="mg-bt-6 pd-y-3 lg-pd-x-5">
        <div className="Row">
          <div className="Column size-12 lg-size-6 lg-pd-7 lg-pd-lt-0 mg-bt-4">
            <div className="border-solid rounded-3 thick-border light-border-4 pd-2 lg-pd-4">
              <h1 className="text-light-4 fs-9 lg-fs-11 text-center">SILVER</h1>
              <p className="text-dark-1 fs-3 text-center">MAXIMUM BENEFIT LIMIT</p>

              <table className="Table mg-x-4 width-full fs-1 xs-fs-2 md-fs-4 lg-fs-3">
                <thead>
                  <tr className="text-center border-bt-solid">
                    <th className="pd-2 border-rt-solid">Age Range</th>
                    <th className="pd-2 border-rt-solid">Daily Hospital Income</th>
                    <th className="pd-2">Personal Accident</th>
                  </tr>
                </thead>

                <tbody>
                  <tr className="text-center border-bt-solid">
                    <td className="pd-2 border-rt-solid">18 - 45</td>
                    <td className="pd-2 border-rt-solid">250</td>
                    <td className="pd-2">10,000</td>
                  </tr>

                  <tr className="text-center border-bt-solid">
                    <td className="pd-2 border-rt-solid">46 - 55</td>
                    <td className="pd-2 border-rt-solid">200</td>
                    <td className="pd-2">10,000</td>
                  </tr>

                  <tr className="text-center">
                    <td className="pd-2 border-rt-solid">56 - 64</td>
                    <td className="pd-2 border-rt-solid">120</td>
                    <td className="pd-2">10,000</td>
                  </tr>
                </tbody>
              </table>

              <div className="Row">
                <div className="Column mg-y-3 text-center text-light-4 ">
                  <p className="fs-4 md-fs-6">MONTHLY</p>
                  <h1 className="fs-7 md-fs-9">100</h1>
                </div>

                <div className="Column mg-y-3 text-center text-light-4 ">
                  <p className="fs-4 md-fs-6">YEARLY</p>
                  <h1 className="fs-7 md-fs-9">1,200</h1>
                </div>
              </div>
            </div>
          </div>

          <div className="Column size-12 lg-size-6 lg-pd-7 lg-pd-rt-0">
            <div className="border-solid rounded-3 thick-border yellow-border-0 pd-2 lg-pd-4">
              <h1 className="text-yellow-0 fs-9 lg-fs-11 text-center">GOLD</h1>
              <p className="text-dark-1 fs-3 text-center">MAXIMUM BENEFIT LIMIT</p>

              <table className="Table mg-x-4 width-full fs-1 xs-fs-2 md-fs-4 lg-fs-3">
                <thead>
                  <tr className="text-center border-bt-solid">
                    <th className="pd-2 border-rt-solid">Age Range</th>
                    <th className="pd-2 border-rt-solid">Daily Hospital Income</th>
                    <th className="pd-2">Personal Accident</th>
                  </tr>
                </thead>

                <tbody>
                  <tr className="text-center border-bt-solid">
                    <td className="pd-2 border-rt-solid">18 - 45</td>
                    <td className="pd-2 border-rt-solid">500</td>
                    <td className="pd-2">15,000</td>
                  </tr>

                  <tr className="text-center border-bt-solid">
                    <td className="pd-2 border-rt-solid">46 - 55</td>
                    <td className="pd-2 border-rt-solid">400</td>
                    <td className="pd-2">15,000</td>
                  </tr>

                  <tr className="text-center">
                    <td className="pd-2 border-rt-solid">56 - 64</td>
                    <td className="pd-2 border-rt-solid">250</td>
                    <td className="pd-2">15,000</td>
                  </tr>
                </tbody>
              </table>

              <div className="Row">
                <div className="Column mg-y-3 text-center text-yellow-0 ">
                  <p className="fs-4 md-fs-6">MONTHLY</p>
                  <h1 className="fs-7 md-fs-9">200</h1>
                </div>

                <div className="Column mg-y-3 text-center text-yellow-0 ">
                  <p className="fs-4 md-fs-6">YEARLY</p>
                  <h1 className="fs-7 md-fs-9">2,400</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="mg-bt-10 pd-y-5">
        <div className="Row">
          <div className="Column size-12 lg-size-6">
            <div className="Row">
              <div className="Column size-12 md-size-6 pd-y-3 mg-bt-6 text-center">
                <h1 className="text-red-5 fs-5">WAITING PERIOD</h1>
                <div className="pos-relative">
                  <div className="pos-absolute center-to-container fs-4">
                    <h1>15 days</h1>
                    <p>from the date of purchase</p>
                  </div>
                  <img src={Waiting} alt="Arrow turning clockwise"/>
                </div>
              </div>

              <div className="Column size-12 md-size-6 pd-y-3 mg-bt-6 text-center">
                <h1 className="text-red-2 fs-5">GRACE PERIOD</h1>
                <div className="pos-relative">
                  <div className="pos-absolute center-to-container fs-4">
                    <h1>31 days</h1>
                    <p>to renew</p>
                  </div>
                  <img src={Grace} alt="Arrow turning clockwise"/>
                </div>
              </div>
            </div>
          </div>

          <div className="Column size-12 lg-size-6 lg-pd-y-6">
            <h1 className="text-red-4 text-center mg-bt-3">Claiming Procedure:</h1>

            <div className="Row mg-bt-2">
              <div className="Column size-1 text-right">
                <img width="32px" height="32px" src={Checkbox} alt="Checkbox Icon"/>
              </div>

              <div className="Column size-11 pd-lt-2">
                <p className="fs-4 mg-bt-2">
                  Filing of claim shall be made upon discharge and submission of documents
                </p>
              </div>
            </div>

            <div className="Row mg-bt-2">
              <div className="Column size-1 text-right">
                <img width="32px" height="32px" src={Checkbox} alt="Checkbox Icon"/>
              </div>

              <div className="Column size-11 pd-lt-2">
                <p className="fs-4">
                  Requirements to claim:
                </p>
              </div>
            </div>

            <ul className="mg-lt-5 md-mg-lt-9">
              <li>Valid ID</li>
              <li>Policy Number</li>
              <li>Evidence of hospitalization, confinement, or death certificate</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="pos-relative pd-bt-6 mg-bt-5 border-tp-dashed thick-border red-border-5">
        <img
          className="pos-absolute pd-lt-2 bg-light-0"
          src={Injection}
          alt="Injection Icon"
          width="172px"
          height="156px"
          style={{top: '-210%'}}
        />
      </section>

      <section className="pd-y-3 lg-pd-y-5 mg-bt-6">
        <h1 className="text-center mg-bt-3">HealthGuard Terms and Conditions</h1>
        <p className="text-justify text-dark-1 lh-half">
          Daily Hospital Income (DHI) Coverage — Person Insured / Benificiary gets cash benefit{' '}
          for each day of hospitalization. 1000 days maximum coverage. One can avail of this{' '}
          even if the first day of hospitalization is the lasy day of the coverage period.{' '}
          Intensive Care Unit (ICU) Coverage — 120 days maximum ICU coverage. Beneficiary gets{' '}
          double the cash benefit of DHI for each day in the hospitals' ICU. Personal Accident{' '}
          (PA) Coverage — beneficiary gets cash benefit upon death of memeber (person insured){' '}
          from accident. 15 days waiting period on the first month before new clients can avail{' '}
          of the DHI and ICU benefits. Multi-use between the coverage period on a case-t-case{' '}
          basis, 2nd episode of hospitalization onward within the coverage period may not require{' '}
          a 3-day minimum hospitalization. 31 days grace period for renewal, after which the{' '}
          the coverage terminates, a new certificate of cover will be in effect upon renewal and{' '}
          a 15 day waiting period will take effect. Upgrade Eligibility Members currently enrolled{' '}
          can upgrade to a higher-value product without any restriction or a 15 day waiting{' '}
          period, provided their coverage have not lapse or expired. Downgrading the policy{' '}
          members can do so but the 15 day waiting period will take effect. Basis for Claims{' '}
          Benefit will be the total number of days in the hospital — date & time of confinement{' '}
          and discharge stated on the hospital Statement of Account (SOA) are required during{' '}
          claims. Valid ID or alternatives (such as birth certificate of the beneficiary) are{' '}
          required during claims. Insurance Coverage will automatically terminate on the date{' '}
          the member turns 65 years old even if the member has remaining coverage period.
        </p>
      </section>

      <section className="pd-x-6 lg-pd-x-10 pd-y-3 lg-pd-y-5" style={FOOTER_BG}>
        <div className="Row">
          <div className="Column size-12 lg-size-3 mg-bt-4 lg-mg-rt-4">
            <p className="text-red-1">Address</p>
            <p>
              Unit 3A, One Orion, 11th Ave. Corner, 38th St.,{' '}
              Bonifacio Global City, Taguig City, 1634
            </p>
          </div>

          <div className="Column size-12 lg-size-3 mg-bt-4">
            <p className="text-red-1">Landline</p>
            <p>(02) 8310 374</p>
          </div>
        </div>

        <div className="Row">
          <div className="Column size-12 lg-size-3 mg-bt-4 lg-mg-rt-4">
            <p className="text-red-1">Email</p>
            <p>info@digipay.ph</p>
          </div>

          <div className="Column size-12 lg-size-3 mg-bt-4">
            <p className="text-red-1">Mobile</p>
            <p>0908 212 4828 (Smart)</p>
            <p>0906 374 0371 (Globe)</p>
          </div>
        </div>

        <div className="Row">
          <a
            href="https://www.facebook.com/digipayph/"
            target="_blank"
            rel="noreferrer noopener"
          >
            <img
              width="48px"
              height="48px"
              src={Facebook}
              alt="Facebook Logo"
              className="mg-rt-2"
            />
          </a>

          <a
            href="https://www.instagram.com/digipayph/"
            target="_blank"
            rel="noreferrer noopener"
          >
            <img
              width="48px"
              height="48px"
              src={Instagram}
              alt="Instagram Logo"
              className="mg-rt-2"
            />
          </a>

          <a
            href="https://ph.linkedin.com/company/digipay"
            target="_blank"
            rel="noreferrer noopener"
          >
            <img
              width="48px"
              height="48px"
              src={LinkedIn}
              alt="LinkedIn Logo"
            />
          </a>
        </div>
      </section>
    </Layout>
  )
}

export default IndexPage
